/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CustomerRegistrationStep = {
    PersonalProfile: 'PERSONAL_PROFILE',
    CompanyDetails: 'COMPANY_DETAILS',
    Address: 'ADDRESS',
    FreightProfile: 'FREIGHT_PROFILE',
    Team: 'TEAM',
    Completed: 'COMPLETED'
} as const;
export type CustomerRegistrationStep = typeof CustomerRegistrationStep[keyof typeof CustomerRegistrationStep];

